<template>
  <el-container class="data-detail-wrip">
    <header>
      <i class="iconfont icon-nav-platform"></i>
      {{renewalDetail.company_name}}
      <i class="iconfont icon-close" @click="closeDialog"></i>
    </header>
    <div class="tab-box">
      <div class="tab-item" :class="(tabType == 0)?'active':''" @click="dtlChange(0)"><span>客户资料</span></div>
      <div class="tab-item" :class="(tabType == 1)?'active':''" @click="dtlChange(1)"><span>操作记录</span></div>
    </div>
    <div class="head" v-if="tabType == 0">
      <span>客户资料</span>
      <el-dropdown trigger="click" @command="handleCommand" v-if="funAuth.includes(20)">
        <span class="el-dropdown-link">
          <i class="el-icon-arrow-down el-icon-more"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="1">删  除</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <el-button type="primary" @click="editDialog">编 辑</el-button> -->
    </div>
    <div class="head" v-if="tabType == 1">
      <span>操作记录</span>
    </div>
    <div class="content">
      <el-collapse v-model="activeNames" v-if="tabType == 0">
        <el-collapse-item name="1">
          <template slot="title">基本信息</template>
          <div class="form">
            <div class="item single">
              <span class="title">客户名称</span>
              <div class="item-content">{{renewalDetail.company_name}}</div>
            </div>
            <div class="item">
              <span class="title">客户姓名</span>
              <div class="item-content">{{renewalDetail.user_name}}</div>
            </div>
            <div class="item">
              <span class="title">联系电话</span>
              <div class="item-content">{{renewalDetail.phone}}</div>
            </div>
            <div class="item">
              <span class="title">套餐开始日期</span>
              <div class="item-content">{{renewalDetail.start_time | formatDate('yyyy-MM-dd')}}</div>
            </div>
            <div class="item">
              <span class="title">套餐结束日期</span>
              <div class="item-content">{{renewalDetail.end_time | formatDate('yyyy-MM-dd')}}</div>
            </div>
            <div class="item single">
              <span class="title">备注</span>
              <div class="item-content">{{renewalDetail.remark}}</div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">系统信息</template>
          <div class="form">
            <div class="item">
              <span class="title">创建人</span>
              <div class="item-content">{{renewalDetail.create_by}}</div>
            </div>
            <div class="item">
              <span class="title">创建时间</span>
              <div class="item-content">{{renewalDetail.create_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
            </div>
            <div class="item">
              <span class="title">修改人</span>
              <div class="item-content">{{renewalDetail.modify_by}}</div>
            </div>
            <div class="item">
              <span class="title">修改时间</span>
              <div class="item-content">{{renewalDetail.modify_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div class="log-box" v-if="tabType == 1">
        <div class="log-item" v-for="(log, index) in logList" :key="index">
          <div class="line">
            <div class="circle"></div>
          </div>
          <div class="rihgt">
            <div class="time">{{log.datetime_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
            <div class="content">{{log.content}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mask n1" v-if="dialogEdit" @click="dialogEdit = false"></div>
    <transition name="slide">
      <renewal-add v-if="dialogEdit" :renewal="renewalDtl"></renewal-add>
    </transition>

    <el-dialog title="提示" :visible.sync="dialogDelete" class="prompt-box" append-to-body>
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">删除</div>
      <div class="note">删除后该公司的续费日期将自动扣掉当前数据叠加的时长。</div>
      <div class="prompt">你确定要删除该续费吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDelete = false">取 消</el-button>
        <el-button type="primary" @click="userDelete">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import mixin from '@/common/js/mixins.js'
import {HTTPServer} from '@/common/js/ajax.js'
import renewalAdd from '@/page/business/renewal-add'// 编辑
import tool from '@/common/js/tool.js'

export default {
  props: ['renewal'],
  mixins: [mixin],
  components: {
    renewalAdd
  },
  data () {
    return {
      renewalDetail: this.renewal,
      activeNames: ['1', '2', '3', '4'],
      tabType: 0,
      moduleId: 5,
      renewalDtl: {},
      dialogEdit: false,
      dialogDelete: false
    }
  },
  mounted () {
    this.queryFchBtnAuth(({moduleId: this.moduleId}))
    // 关闭添加窗口
    this.$bus.on('closeAddModal', (value) => {
      if (value) {
        this.dialogEdit = false
      }
    })
  },
  methods: {
    // 关闭详情弹框
    closeDialog () {
      this.$bus.emit('closeAddDetailModal', true)
    },
    /** 详情导航切换 */
    dtlChange (type) {
      this.tabType = type
      if (type === 1) {
        this.queryRecordList({moduleType: this.moduleId, moduleId: this.renewalDetail.id})
      }
    },
    /** 编辑续费 */
    editDialog () {
      this.dialogEdit = true
      this.renewalDtl = {'id': this.renewalDetail.id, 'account_id': this.renewalDetail.account_id, 'company_name': this.renewalDetail.company_name, 'user_name': this.renewalDetail.user_name, 'phone': this.renewalDetail.phone, 'start_time': this.renewalDetail.start_time, 'end_time': this.renewalDetail.end_time, 'remark': this.renewalDetail.remark}
    },
    /** 点击菜单项触发的事件回调 */
    handleCommand (command) {
      if (command === '1') {
        this.dialogDelete = true
      }
    },
    /** 续费删除 */
    userDelete () {
      let jsondata = {
        'id': this.renewalDetail.id,
        'accountId': this.renewalDetail.account_id,
        'oldData': this.renewalDetail
      }
      jsondata.operatorRecord = tool.formatDate(this.renewal.start_time, 'yyyy-MM-dd') + ' - ' + tool.formatDate(this.renewal.end_time, 'yyyy-MM-dd')
      HTTPServer.delRenewal(jsondata, 'Loading').then((res) => {
        this.dialogDelete = false
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.$bus.emit('query-renewal-list', true, true)
        this.$bus.emit('closeAddDetailModal', true)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/business/renewal-detail.vue